<template>

    <v-chart class="chart__display" :option="option" autoresize />

</template>

<script>

import { use } from 'echarts/core';
import { GridComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart } from 'echarts/charts';
import VChart from 'vue-echarts';
import { ref, defineComponent } from 'vue';

use([
  BarChart,
  CanvasRenderer,
  GridComponent
]);

export default defineComponent({
  name: 'BarChart',
  components: {
    VChart
  },
  props: ['id'],
  setup(props) {
    (async () => {      try {
        const res = await fetch(`/api/collections/programs/entries/${props.id}`); 
        const { data } = await res.json() 

        const globalDataRes = await fetch(`/api/globals/dataviz`);
        const globalData = await globalDataRes.json(); 

        function adjustedValue(incoming) {
          if (incoming < data.program_longterm_impact_total_adjusted / 100 || incoming < data.program_longterm_impact_total_potential / 100) {
            return {value: incoming, label: {show: false}}
          } else {
            return incoming
          }
        }

        option.value.xAxis[0].data = [`${globalData.data.nearterm_start_year} - ${globalData.data.nearterm_end_year}`, `${globalData.data.nearterm_start_year} - ${globalData.data.longterm_end_year}`];

        option.value.series[0].data = [adjustedValue(data.program_nearterm_impact_total_adjusted), adjustedValue(data.program_longterm_impact_total_adjusted)]
        
        option.value.series[1].data = [adjustedValue(data.program_nearterm_impact_total_potential - data.program_nearterm_impact_total_adjusted), adjustedValue(data.program_longterm_impact_total_potential - data.program_longterm_impact_total_adjusted)]

      } catch (e) { }
    })()

    const option = ref({
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: []
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: '{value}M'
          }
        }
      ],
      series: [
        {
          name: 'adjusted est. contained',
          type: 'bar',
          stack: 'terms',
          color: '#F3C262',
          label: {
            show: true,
            formatter: '{c}M\n{a}',
          },
          data: []
        },
        {
          name: 'potential\nadditional est. contained',
          type: 'bar',
          stack: 'terms',
          color: '#BD8100',
          label: {
            show: true,
            formatter: '{c}M\n{a}',
          },
          data: []
        }
      ]
    });

    return { option };
  },
})
</script>